<div class="sec-title" id="topofpage">
    <h1>Modifier la soumission #{{submissionInfo.submission_no}}</h1>
</div>
<div><a class="btn btn-action" href="/soumissions" routerLink="/soumissions" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux soumissions</a></div>
<div style="width:100%;">
<div class="alert alert-success p-3"  role="alert" *ngIf="update_message!=''">{{update_message}}</div>
<form [formGroup]="editSubmissionForm" (ngSubmit)="onSubmit(editSubmissionForm.value)" novalidate>
    <fieldset class="col-12 float-lg-left form-group mb-3">
        <legend>Informations Soumission</legend>
        <div class="fieldset-wrap">
            <div class=" float-lg-start me-5 col-sm-12 col-lg-5">
                <fieldset [ngClass]="{'client-lg-fr' : clientInfo.client_language_code == 'FR', 'client-lg-en' : clientInfo.client_language_code == 'EN' }" >
                    <legend class="sub-label">Info Client</legend>
                    <div class="infobox fieldset-wrap">
                        <div class="float-lg-start col-sm-12 col-lg-5">
                            <div class="mb-2"><a routerLink="/client/{{clientInfo.client_id}}/editer" class="card-link"><button type="button" class="btn btn-outline-secondary action-btn"><i class="bi bi-pencil-square"  data-toggle="tooltip" data-placement="top" title="Modifier le client"></i> modifier le client</button></a></div>
                            <div class="form-group mb-2">
                                <label class="form-label">Client</label>
                                <span *ngIf="clientInfo.client_gender == 'F'; then femme_label else homme_label ">
                                </span>
                                
                                <ng-template #femme_label>
                                    (FEMME)
                                </ng-template>
                                <ng-template #homme_label>
                                    (HOMME)
                                </ng-template>
                                <span> {{clientInfo.client_fname}} {{clientInfo.client_lname}}</span>
                                
                            </div>

                            <div class="form-group mb-2">
                                <label class="form-label">Adresse propriétaire</label>
                                <span>{{clientInfo.client_address}}, {{clientInfo.client_city}}, {{clientInfo.client_province}}<br></span>
                                <span>{{clientInfo.client_postalcode}} </span>
                            </div>

                            <div class="form-group mb-2">
                                <label class="form-label">Langue</label>
                                <span>{{clientInfo.client_language_name}}</span>
                            </div>

                            <div class="form-group mb-2">
                                <label class="form-label">Provenance</label>
                                <span>{{clientInfo.client_referral_name}} <span *ngIf="clientInfo.client_referral_note != ''"> ( {{clientInfo.client_referral_note}} )</span></span>
                            </div>
                        </div>
                        <div class="float-lg-end col-sm-12 col-lg-6">
                            <div class="form-group mb-2" *ngFor="let contact of clientInfo.contacts">
                                <label class="form-label">{{contact.client_contact_type_name}}</label>
                                <span *ngIf="contact.client_contact_type_id == 4 || contact.client_contact_type_id == 2 || contact.client_contact_type_id == 1; else nolinkdiv">
                                    <span *ngIf="contact.client_contact_type_id == 4">
                                        <a href="mailto:{{contact.value}}"><button type="button" class="btn btn-outline-primary btn-contact"><i class="bi bi-envelope-fill"></i></button> {{contact.value || 'N/A'}}</a>
                                    </span>
                                    <span *ngIf="contact.client_contact_type_id == 1 || contact.client_contact_type_id == 2">
                                        <a href="tel:{{sanitizePhone(contact.value)}}"><button type="button" class="btn btn-outline-primary btn-contact"><i class="bi bi-telephone-fill"></i></button> {{contact.value || 'N/A'}}</a>
                                    </span>
                                </span>
                                <ng-template #nolinkdiv>
                                    <span>{{contact.value || 'N/A'}}</span>
                                </ng-template>
                            </div>
                        </div>
                        
                    </div>
                </fieldset>
                
            </div>
            <div class="float-lg-start col-sm-12 col-lg-6 mt-2">
                <div class="form-group mb-3">
                    <label for="submission_no" class="form-label">Numéro de soumission</label>
                    <input  *ngIf="!isForeman" type="text" class="form-control" name="submission_no" id="submission_no" formControlName="submission_no" />
                    <span  *ngIf="isForeman" >{{submissionInfo.submission_no}}</span>
                </div>

                <div class="form-group mb-3">
                    <label for="soumission_created_date" class="form-label">Date de création</label>
                    <input  *ngIf="!isForeman" type="text" class="form-control flatpickr flatpickr-input" name="soumission_created_date" id="soumission_created_date" formControlName="soumission_created_date" />
                    <span  *ngIf="isForeman" >{{submissionInfo.soumission_created_date_visual}}</span>
                    par {{submissionInfo.created_by_name}}
                </div>
                <div class="form-group mb-3">
                    <label for="latest_appointment_date" class="form-label">RENDEZ-VOUS VENDEUR</label>
                    {{submissionInfo.latest_appointment_date}}
                    <span *ngIf='latest_appointment_date_planned==false'>
                        Rendez-vous non planifié
                    </span>
                    <span *ngIf='latest_appointment_date_planned==true'>
                        <br>Vendeur : {{submissionInfo.latest_appointment_account}}

                    </span>
                </div>
                <div class="form-group mb-3">
                    <label for="latest_job_date" class="form-label">Date des travaux</label>
                    {{submissionInfo.latest_job_date}}
                    <span *ngIf='submissionInfo.is_job_planned==false'>
                        Job non planifié
                    </span>
                </div>
            <div  *ngIf="isForeman" class="float-lg-start form-group mb-3 me-3">
                    <a (click)="invoicePdf(invoiceInfo.invoice_id, invoiceInfo.invoice_no)"  role="button"><i class="bi bi-file-earmark-pdf-fill btn-add-one"></i><span class="txt-add-one ms-2">Facture en PDF</span></a>
            </div>
        
            <fieldset *ngIf="isForeman" >
                <legend class="sub-label">Adresse des travaux</legend>
                <div  class="fieldset-wrap">
                    <div class="fieldset-wrap">
                        <div class=" float-lg-start me-5 col-sm-12 col-lg-5">
                            <div class="form-group mb-3">
                                <label for="address" class="form-label">Adresse</label>
                                {{this.submissionInfo.address}} {{this.submissionInfo.address2}}, {{this.submissionInfo.city}} {{this.submissionInfo.province}}, {{this.submissionInfo.postalcode}} {{this.submissionInfo.country}}
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        </div>
    </fieldset>
    <fieldset class="col-12 float-lg-left form-group mb-3">
        <legend>Status de la soumission</legend>
        <div class="fieldset-wrap" name="top" style="overflow:hidden;" id="top">
        <div *ngIf="!isForeman"  class="fieldset-wrap bg-light float-lg-end col-sm-12 col-lg-6 ">
            <div class="sub-label">Maquettes disponibles</div>
            <ul class="list-inline">
                <li *ngFor="let template of templatesList"  class="list-inline me-1">
                    <a href="#" (click)="proposition(template.template_id, template.template_name)" data-bs-toggle="modal" data-bs-target="#proposalModal">
                        <span class="badge rounded-pill text-bg-primary">{{template.template_name}}</span>
                    </a>
                </li>
            </ul>
            <div class="sub-label">Proposition(s) existante(s)</div>
            <div class="alert alert-success p-1"  role="alert" *ngIf="update_message_prop!=''">{{update_message_prop}}</div>
            <table class="table table-striped">
                <thead>
                    <th>Envoyé</th>
                    <th>Proposition</th>
                    <th>Action</th>
                </thead>
                <tbody class="table-proposition">
                    <tr *ngIf="propositionsList.length === 0">
                        <td colspan="3" class="text-center">Aucune</td>
                    </tr>
                    <tr *ngFor="let proposition of propositionsList">
                        <td class="prop_sent">
                            <i *ngIf="proposition.email_date" width="16" height="16"  class="bi bi-check-circle-fill txt-active"></i>
                            <i *ngIf="proposition.email_date == null" width="16" height="16"  class="bi bi-check-circle-fill txt-inactive"></i>
                        </td>
                        <td><div class="mb-1">{{proposition.proposition_name}}</div>
                            <div *ngIf="proposition.email_date">
                                <span class="prop_date"><label for="proposition_created" class="form-label-inline col-1">Envoyée le :</label> {{proposition.email_date | date:'medium'}} </span>
                            </div>
                            <div *ngIf="!proposition.email_date">
                                <span class="prop_date"><label for="proposition_created" class="form-label-inline col-1"></label>Pas encore envoyée</span>
                            </div>
                            </td>
                        <td>
                            <a (click)="propositionEdit(proposition.proposition_id)" title="modifier" data-bs-toggle="modal" data-bs-target="#proposalEditModal"><i class="bi bi-pencil-fill"></i></a>
                            <a (click)="propositionDuplicate(proposition.proposition_id, proposition.proposition_name)"  title="dupliquer"><i class="bi bi-files"></i></a>
                            <a (click)="propositionPrintPDF(proposition.proposition_id, proposition.proposition_name)" title="imprimer"><i class="bi bi-printer"></i></a>
                            <a (click)="propositionPdf(proposition.proposition_id, proposition.proposition_name)" title="exporter en PDF"><i class="bi bi-file-earmark-pdf"></i></a>
                            <a (click)="propositionEmail(proposition.proposition_id)" title="envoyer au client par courriel"><i class="bi bi-envelope-paper"></i></a>
                            <a (click)="propositionDelete(proposition.proposition_id, proposition.updated)" title="supprimer" class="float-lg-end btn_nopad"><i class="bi bi-file-x-fill btn-delete"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
            <div  *ngIf="!isForeman"  class="float-lg-start col-sm-12 col-lg-5 soumission-etat">
                <div class="sub-label">États de la soumision</div>
                <div class="float-start col-sm-2 col-lg-1 soumission">
                    <div class="progress">
                        <div class="progress-bar" [ngClass]="{'bg-signed' : submissionInfo.is_signed }"  role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        <div class="progress-bar" [ngClass]="{'bg-notsigned' : submissionInfo.is_accepted }"  role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        <div class="progress-bar" [ngClass]="{'bg-sent' : submissionInfo.is_sent }" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        <div class="progress-bar" [ngClass]="{'bg-rendezvous' : submissionInfo.is_scheduled }" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        <div class="progress-bar" [ngClass]="{'bg-refused': submissionInfo.is_refused }" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        
                    </div>
                </div>
                <div class="float-start col-sm-10 col-lg-11">
                    <div class="float-lg-start col-sm-12 col-lg-12">
                        <ul class="list-group">
                            <li class="list-group-item">
                                <input type="checkbox" class="float-lg-start form-check-input" id="is_refused" formControlName="is_refused">
                                <label for="is_refused" class="form-check-label d-inline ms-3">Soumission refusée</label>
                            </li>
                            <li class="list-group-item">
                                <input type="checkbox" class="float-lg-start form-check-input" id="is_scheduled" formControlName="is_scheduled">
                                <label for="is_scheduled" class="form-check-label d-inline ms-3">Rendez-vous fixé</label>
                            </li>
                            <li class="list-group-item">
                                <input type="checkbox" class="float-lg-start form-check-input" id="is_sent" formControlName="is_sent">
                                <label for="is_sent" class="form-check-label d-inline ms-3">Soumission envoyée</label>
                            </li>
                            <li class="list-group-item">
                                <input type="checkbox" class="float-lg-start form-check-input" id="is_accepted" formControlName="is_accepted">
                                <label for="is_accepted" class="form-check-label d-inline ms-3">Soumission acceptée non signée</label>
                            </li>
                            <li class="list-group-item">
                                <input type="checkbox" class="float-lg-start form-check-input" id="is_signed" formControlName="is_signed">
                                <label for="is_signed" class="form-check-label d-inline ms-3">Soumission signée</label>
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>
            <div class="float-lg-start col-sm-12 col-lg-5 mt-5">
                <div class="sub-label">Ajouter des Documents</div>
                <div class="file-upload file-list mb-2">
                    <input type="file" multiple class="form-control upload-field mb-2" name="submission_files" id="submission_files" (change)="onFileSelected($event)" />  
                    <ul *ngIf="fileList.length" id="file-upload-container">
                        <li *ngFor="let oneFile of fileList; let i = index" class="btn btn-files col-10">
                            <span class="btn btn-files-inner col-10 ms-4" >{{oneFile.name}}</span>
                            <a href="javascript:void(0);" (click)="deleteFile(i)" role="button" class="btn-delete"><i class="bi bi-file-x-fill"></i></a>
                        </li> 
                        <div>
                            <button type="submit" class="float-start btn btn-primary mt-3 me-3">Télécharger</button>
                            <div class="float-start alert alert-success p-3"  role="alert" *ngIf="update_message_upload!=''">{{update_message_upload}} </div>
                        </div>              
                    </ul>
                  
                </div>
                <div class="files-uploaded">
                <div class="sub-label">Documents Existants</div>
                <div class="file-list">
                    <ul>
                        <li *ngFor="let uloadedFile of uploadedFiles; let i = index"  class="btn btn-files col-10">
                            <a href="javascript:void(0);" (click)="fileDownload(uloadedFile.note_id, uloadedFile.subject, uloadedFile.content_type )" role="button" class="btn-download" download="{{uloadedFile.subject}}"><i class="bi bi-box-arrow-down"></i></a>
                            <span class="btn btn-files-inner col-10" (click)="fileExport(uloadedFile.note_id, uloadedFile.subject, uloadedFile.content_type )" >{{uloadedFile.subject}}</span>
                            <a href="javascript:void(0);" (click)="deleteExistingFile(uloadedFile.note_id, uloadedFile.subject)" role="button" class="btn-delete"><i class="bi bi-file-x-fill"></i></a>
                        </li>
                        <li *ngIf="!uploadedFiles.length">
                            Aucun document 
                        </li>
                    </ul>
                </div>
            </div>
            <button type="submit" class="float-start btn btn-primary mt-3 me-3">Enregistrer</button><div class="float-start alert alert-success p-3"  role="alert" *ngIf="update_message!=''">{{update_message}}  {{submissionInfo.updated  | date:'HH:mm:ss'}} </div>
        </div>
       
           
        </div>
    </fieldset>
    <fieldset *ngIf="!isForeman" class="col-sm-12 col-lg-12 form-group mb-3">
        <legend>Adresse des travaux</legend>
        <div class="fieldset-wrap">
            <div class=" float-lg-start me-5 col-sm-12 col-lg-5">
                <div class="form-group mb-3">
                    <label for="address" class="form-label">Adresse</label>
                    <input type="text" class="form-control" name="address" id="address" formControlName="address" />
                </div>
                
                <div class="form-group mb-3">
                    <label for="city" class="form-label">Ville</label>
                    <input type="text" class="form-control" name="city" id="city" formControlName="city" />
                </div>

                <div class="form-group mb-3">
                    <label for="postalcode" class="form-label">Code postale</label>
                    <input type="text" class="form-control" name="postalcode" id="postalcode" formControlName="postalcode" />
                </div>

            </div>
            <div class="float-lg-start col-sm-12 col-lg-6">

                <div class="form-group mb-3">
                    <label for="address2" class="form-label">App/Suite</label>
                    <input type="text" class="form-control w-20" name="address2" id="address2" formControlName="address2" />
                </div>

                <div class="form-group mb-3">
                    <label for="province" class="form-label">Province</label>
                    <input type="text" class="form-control" name="province" id="province" formControlName="province" />
                </div>

               
                <div class="form-group mb-3">
                    <label for="country" class="form-label">Pays</label>
                    <input type="text" class="form-control" name="country" id="country" formControlName="country" />
                </div>
            </div>
        </div>
    </fieldset>

    <fieldset *ngIf="!isForeman" class="col-12 float-lg-left form-group mb-3">
        <legend>Informations des travaux</legend>
        <div class="fieldset-wrap">
            <div class="col-sm-12 col-lg-12">
                <div class="col-sm-12 col-lg-12">
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label for="roof_type_id" class="form-label">Type de toit</label>
                        <select class="form-select" name="roof_type_id" id="roof_type_id" formControlName="roof_type_id">
                            <option *ngFor="let roofType of roofTypesList" [value]="roofType.roof_type_id">
                                {{roofType.name}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label for="roof_description" class="form-label">Note type de toit</label>
                        <textarea class="form-control" name="roof_description" id="roof_description" formControlName="roof_description"></textarea>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-12">
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label for="building_type_id" class="form-label">Type de maison</label>
                        <select class="form-select" name="building_type_id" id="building_type_id" formControlName="building_type_id">
                            <option *ngFor="let buildingType of buildingTypesList" [value]="buildingType.building_type_id">
                                {{buildingType.name}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label for="building_description" class="form-label">Note type de maison</label>
                        <textarea class="form-control" name="building_description" id="building_description" formControlName="building_description"></textarea>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-12">
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label for="building_access_id" class="form-label">Accès au toit</label>
                        <select class="form-select" name="building_access_id" id="building_access_id" formControlName="building_access_id">
                            <option *ngFor="let buildingAccessType of buildingAccessTypesList" [value]="buildingAccessType.building_access_id">
                                {{buildingAccessType.name}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label for="roof_access" class="form-label">Note accès au toit</label>
                        <textarea class="form-control" name="roof_access" id="roof_access" formControlName="roof_access"></textarea>
                    </div>    
                </div>     
                <div class="col-sm-12 col-lg-12">
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label  class="form-label">Infiltration d'eau</label>
                        <div class="col-sm-12 col-lg-12 mt-2 mb-2">
                            <span>
                                <input type="radio" [checked]="submissionInfo.has_water_infiltration === false" class="custom-control-input d-inline-flex me-2 col-sm-3 float-lg-left" value="false" name="has_water_infiltration" id="has_water_infiltration" formControlName="has_water_infiltration" required>
                                <label class="custom-control-label d-inline-flex col-sm-3 float-lg-left" for="non">Non</label>
                            </span>
                            <span>
                                <input type="radio" [checked]="submissionInfo.has_water_infiltration === true" class="custom-control-input d-inline-flex me-2 col-sm-3 float-lg-left" value="true" name="has_water_infiltration" id="has_water_infiltration" formControlName="has_water_infiltration" required>
                                <label class="custom-control-label d-inline-flex col-sm-3 float-lg-left" for="oui">Oui</label>
                            </span>
                        </div>
                    </div>
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label for="water_infiltration" class="form-label">Note infiltration d'eau</label>
                        <textarea class="form-control" name="water_infiltration" id="water_infiltration" formControlName="water_infiltration"></textarea>
                    </div>    
                </div>         
            </div>
        </div>
    </fieldset>
    <fieldset *ngIf="!isForeman" class="col-12 float-lg-left form-group mb-3">
        <legend>Informations supplémentaires</legend>
        <div class="fieldset-wrap">
                <div class="col-sm-12 col-lg-12">
                    <div class="col-sm-12 col-lg-12">
                        <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                            <div class="col-sm-12 col-lg-12 ">
                                <label  class="form-label col-sm-12 col-lg-12">Maison neuve?</label>
                            </div>
                            <span class="col-sm-6 col-lg-6">
                                <input type="radio" [checked]="submissionInfo.is_new === false" class="custom-control-input d-inline-flex me-2 col-sm-3 float-lg-left" value="false" name="is_new" id="is_new" formControlName="is_new" required>
                                <label class="custom-control-label d-inline-flex col-sm-3 float-lg-left" for="non">Non</label>
                            </span>
                            <span class="col-sm-6 col-lg-6">
                                    <input type="radio" [checked]="submissionInfo.is_new === true" class="custom-control-input d-inline-flex me-2 col-sm-3 float-lg-left" value="true" name="is_new" id="is_new" formControlName="is_new" required>
                                    <label class="custom-control-label d-inline-flex col-sm-3 float-lg-left" for="oui">Oui</label>
                            </span>
                     
                        </div>
                    </div>
                    <div class="float-lg-start col-sm-12 col-lg-7">
                        <div class="form-group mb-3">
                            <label for="building_age" class="form-label">Propriétaire depuis combien d'année?</label>
                            <textarea class="form-control" name="building_age" id="building_age" formControlName="building_age"></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-12">
                    <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-lg-7">
                        <label  class="form-label">Toit déjà refait?</label>
                        <div class="col-sm-12 col-lg-12 mt-2 mb-2">
                            <span>
                                <input type="radio" [checked]="submissionInfo.is_roof_redone === false" class="custom-control-input d-inline-flex me-2 col-sm-3 float-lg-left" value="false" name="is_roof_redone" id="is_roof_redone" formControlName="is_roof_redone" required>
                                <label class="custom-control-label d-inline-flex col-sm-3 float-lg-left" for="non">Non</label>
                            </span>
                            <span>
                                <input type="radio" [checked]="submissionInfo.is_roof_redone === true" class="custom-control-input d-inline-flex me-2 col-sm-3 float-lg-left" value="true" name="is_roof_redone" id="is_roof_redone" formControlName="is_roof_redone" required>
                                <label class="custom-control-label d-inline-flex col-sm-3 float-lg-left" for="oui">Oui</label>
                            </span>
                        </div>
                    </div>
                    <div class="float-lg-start col-sm-12 col-lg-7">
                        <div class="form-group mb-3">
                            <label for="roof_date" class="form-label">Date de re-fabrication du toit (Année)</label>
                            <textarea class="form-control" name="roof_date" id="roof_date" formControlName="roof_date"></textarea>
                        </div>
                    </div>
                </div> 
            
                <div class="col-sm-12 col-lg-12">
                    <div class="form-group float-lg-start mb-3 col-sm-12 col-lg-7">
                        <label for="description" class="form-label">Note générale</label>
                        <textarea class="form-control" rows="8"  name="description" id="description" formControlName="description"></textarea>
                    </div>
                </div>
        </div>
    </fieldset>
    <fieldset *ngIf="!isForeman" class="col-12 float-lg-left form-group mb-3">
        <legend>Suivi des appels</legend>
        <div class="fieldset-wrap">
            <div class="col-sm-12 col-lg-12">
                <!-- suivis start -->
                 <div  *ngFor="let suiviNote of suiviNotesList; let i = index" class="form-group mb-3 mt-3 col-lg-12"> 
                    <div class="col-sm-12 col-lg-12 float-start mb-3">
                        <div class="float-start me-3 mb-3 col-lg-3">
                            <div class="col-12 mb-2">
                                <input type="hidden" value="{{suiviNote.note_id}}" name="note_id_{{i}}" id="note_id_{{i}}" formControlName="note_id_{{i}}"  >
                                <label for="created" class="form-label float-start me-2">Date création :</label>
                                {{suiviNote.created }}
                            </div>
                            <div class="col-12 mb-2">
                                <label for="first_name" class="form-label float-start me-2">Créé par :</label>
                                {{suiviNote.first_name}} {{suiviNote.last_name}}
                                <span class="suivi_note" *ngIf='suiviNote.note_type_id==3'>***ATTENTION*** Suivi associé avec un rendez-vous</span>
                            </div>
                            <div class="col-12 mb-2">  
                                <label for="start_date" class="form-label float-start me-2" >Prochain suivi :</label>
                                <input *ngIf="i == suiviNotesList.length-1" type="text" class="form-control flatpickr flatpickr-input" name="note_start_date_{{i}}" id="note_start_date_pkr_{{i}}" formControlName="note_start_date_{{i}}" >
                                <span *ngIf="i < suiviNotesList.length-1">{{suiviNote.end_date}} </span>  
                            </div>
                        </div>
                        <div class="form-group float-start me-3 col-lg-7 col-sm-12">
                            <span class="float-start col-sm-10" [ngClass]="{'client-lg-fr' : clientInfo.client_language_code == 'FR', 'client-lg-en' : clientInfo.client_language_code == 'EN' }" >
                                <textarea class="form-control" rows="6" name="note_suivi_{{i}}" id="note_suivi_{{i}}" formControlName="note_suivi_{{i}}" >{{suiviNote.body}}</textarea>
                            </span>
                            <span class="float-start col-sm-1 ms-3">
                                <a href="javascript:void(0);" (click)="deleteSuiviNote(i, suiviNote.note_id)" role="button" class="btn-delete" title="supprimer le suivi"><i class="bi bi-file-x-fill"></i></a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="float-start alert alert-warning p-3"  role="alert" *ngIf="update_message_suivi!=''">{{update_message_suivi}} </div>
                <!-- suivis end -->
                <div class="float-start col-12">
                    <div class="form-group mb-3 ms-3">
                        <a href="javascript:void(0);" (click)="addSuiviNote()" role="button"><i class="bi bi-plus-circle-fill btn-add-one" ></i><span class="txt-add-one ms-2">Ajouter un suivi</span></a>
                      </div>
                </div>

                <div class="col-sm-12 col-lg-12">
                    <div class="form-group float-lg-end mb-3 col-sm-12 col-lg-3">
                        <label class="form-label">États des suivis</label>
                        <div class="form-group float-lg-start mb-3 me-4 col-sm-12 col-3">
                            <div class="col-sm-12 col-lg-12 mt-2 mb-2">
                                <span>
                                    <input type="radio" [checked]="submissionInfo.is_suivi_active === false" class="custom-control-input d-inline-flex me-2 col-sm-3 float-lg-left" [value]="false" name="is_suivi_active" id="is_suivi_active" formControlName="is_suivi_active" required>
                                    <label class="custom-control-label d-inline-flex col-sm-3 float-lg-left" for="non">Fermé</label>
                                </span>
                                <span>
                                    <input type="radio" [checked]="submissionInfo.is_suivi_active === true" class="custom-control-input d-inline-flex me-2 col-sm-3 float-lg-left" [value]="true" name="is_suivi_active" id="is_suivi_active" formControlName="is_suivi_active" required>
                                    <label class="custom-control-label d-inline-flex col-sm-3 float-lg-left" for="oui">Ouvert</label>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <div class="alert alert-success p-3"  role="alert" *ngIf="update_message!=''">{{update_message}}  {{submissionInfo.updated  | date:'HH:mm:ss'}} </div>
    <div class="mb-3 mt-2">
        <span class="sub-label">Date de création :</span> {{submissionInfo.created  | date:'medium'}}<br/>
        <span class="sub-label">Dernière mise à jour :</span> {{submissionInfo.updated  | date:'medium'}}  - <span class="sub-label">par : </span>{{submissionInfo.created_by_name}}
    </div>
    <button type="submit" class="btn btn-primary" >Enregistrer</button>
</form>
<hr />
</div>
<div id="proposalModal" class="modal fade" tabindex="-1">
    <!-- Vertically centered scrollable modal -->
    <div class="modal-dialog modal-xl  modal-dialog-scrollable">
        <form [formGroup]="addPropositionForm" (ngSubmit)="saveProposition(addPropositionForm.value)" novalidate>
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{propositionTemplateName}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                </div>
                <div class="mb-3 ms-3 mt-3 col-sm-12 col-lg-12">
                    <div class="float-lg-start col-sm-6 col-lg-6">
                        <label for="proposition_name" class="form-label">Nom de la soumisison</label>
                        {{propositionTemplateName}}
                        <input type="hidden" class="form-control" name="proposition_name" id="proposition_name" formControlName="proposition_name" />
                    </div>
                    <div class="col-sm-6 col-lg-6">
                        <label for="proposition_name" class="form-label">Nom du client</label>
                        {{clientInfo.client_fname}} {{clientInfo.client_lname}}
                    </div>
                    <div class="float-lg-end col-sm-6 col-lg-6">
                        <label for="proposition_name" class="form-label">Adresse des travaux</label>
                         {{submissionInfo.address}}
                    </div>
                </div>
                <div class="modal-body">
                    
                    <div class="form-group mb-3 col-sm-12 col-lg-12">
                        <ckeditor [config]="ckEditorWithImageConfig" (init)="readyCKEditor($event)" name="proposition_content" id="proposition_content" formControlName="proposition_content" data="{{propositionTemplate}}"></ckeditor>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                    <button type="submit" class="btn btn-primary">Sauvegarder</button>
                </div>
            </div>
        </form>
    </div>
</div>

<div id="proposalEditModal" class="modal fade" tabindex="-1">
    <!-- Vertically centered scrollable modal -->
    <div class="modal-dialog modal-xl  modal-dialog-scrollable">
        <form [formGroup]="updatePropositionForm" (ngSubmit)="updateProposition(updatePropositionForm.value)" novalidate>
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{propositionName}}</h5>
                    <button type="button" id="updatePropositionForm-close" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                </div>
                <div class="mb-3 ms-3 mt-3 col-sm-12 col-lg-12">
                    <div class="float-lg-start col-sm-6 col-lg-6">
                        <label for="proposition_name" class="form-label">Nom de la soumission:</label>
                        {{propositionName}}
                        <input type="hidden" class="form-control" name="proposition_name" id="proposition_name" formControlName="proposition_name" value="{{propositionName}}" />
                        <div class="mt-3 smaller">
                            <label for="proposition_created" class="form-label-inline col-1">Ajoutée: </label> {{propositionCreated | date:'medium'}}</div>
                        <div class="smaller">    
                            <label for="proposition_updated" class="form-label-inline col-1">Changée :</label> {{propositionLastUpdated | date:'medium'}}
                        </div>
                        <div class="smaller">    
                            <div *ngIf="propositionFirstSent">
                              <label for="proposition_sent" class="form-label-inline col-1">Envoyée :</label> {{propositionFirstSent | date:'medium'}} (première fois)
                            </div>
                        </div>
                    </div>
                    <div class="float-lg-start col-sm-6 col-lg-6">
                        <label for="proposition_name" class="form-label">Nom du client</label>
                        {{clientInfo.client_fname}} {{clientInfo.client_lname}}
                    </div>
                    <div class="float-lg-end col-sm-6 col-lg-6">
                        <label for="proposition_name" class="form-label">Adresse des travaux</label>
                        {{submissionInfo.address}} {{submissionInfo.address2}} {{submissionInfo.city}}
                    </div>
                </div>
                <div class="modal-body">
                    <div class="form-group mb-3">
                        <ckeditor name="proposition_content" id="proposition_content" formControlName="proposition_content" data="{{propositionContent}}"></ckeditor>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                    <button type="submit" class="btn btn-primary">Sauvegarder</button>
                </div>
            </div>
        </form>
    </div>
</div>

<div id="print-section"></div>